module.exports = __webpack_public_path__ + "img/james_2.e193750f.jpg";